document.addEventListener('DOMContentLoaded', function () {
    const sliderTracks = document.querySelectorAll('.slider-track');

    sliderTracks.forEach(track => {
        const gallery = track.closest('.product-gallery');
        if (!gallery) return;

        const slides = track.querySelectorAll('.slider-slide');
        const dots = gallery.querySelectorAll('.slider-dot');
        const thumbnails = gallery.querySelectorAll('.thumbnail-item');
        const prevBtn = gallery.querySelector('.slider-prev');
        const nextBtn = gallery.querySelector('.slider-next');

        // Update Active State
        function updateActiveState(index) {
            // Update Dots
            dots.forEach((dot, i) => {
                if (i === index) dot.classList.add('active');
                else dot.classList.remove('active');
            });

            // Update Thumbnails
            thumbnails.forEach((thumb, i) => {
                if (i === index) thumb.classList.add('active');
                else thumb.classList.remove('active');
            });
        }

        // Scroll to Slide
        function scrollToSlide(index) {
            if (!slides[index]) return;

            slides[index].scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',
                inline: 'start'
            });
            updateActiveState(index);
        }

        // Identify current index based on scroll
        track.addEventListener('scroll', () => {
            let scrollLeft = track.scrollLeft;
            let slideWidth = slides[0].offsetWidth;
            let index = Math.round(scrollLeft / slideWidth);
            updateActiveState(index);
        });

        // Touch events for drag/swipe (native scroll-snap handles most, but we can enhance)

        // Thumbnail Click
        thumbnails.forEach((thumb, i) => {
            thumb.addEventListener('click', (e) => {
                e.preventDefault();
                scrollToSlide(i);
            });
        });

        // Arrow Click
        if (prevBtn) {
            prevBtn.addEventListener('click', (e) => {
                e.preventDefault();
                let currentIndex = Array.from(dots).findIndex(d => d.classList.contains('active'));
                if (currentIndex > 0) scrollToSlide(currentIndex - 1);
                else scrollToSlide(slides.length - 1); // Loop
            });
        }

        if (nextBtn) {
            nextBtn.addEventListener('click', (e) => {
                e.preventDefault();
                let currentIndex = Array.from(dots).findIndex(d => d.classList.contains('active'));
                if (currentIndex < slides.length - 1) scrollToSlide(currentIndex + 1);
                else scrollToSlide(0); // Loop
            });
        }
    });
});
